const t = {
  name: "Madrid",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.19175 4H11.2372L8.23716 18H15.7632L12.7632 4H18.8086L22.2372 20H1.76318L5.19175 4ZM19.7632 18L17.1918 6H15.2372L17.8086 18H19.7632ZM8.76318 6H6.80859L4.23716 18H6.19175L8.76318 6Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Madrid
};
